import { render } from "./CmsRevisionSelectorPopup.vue?vue&type=template&id=ff896738&scoped=true"
import script from "./CmsRevisionSelectorPopup.vue?vue&type=script&lang=js"
export * from "./CmsRevisionSelectorPopup.vue?vue&type=script&lang=js"

import "./CmsRevisionSelectorPopup.vue?vue&type=style&index=0&id=ff896738&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff896738"]])

export default __exports__